import "./User.css";

const UserModal = ({
  modalRef,
  form,
  handleChange,
  handleSubmit,
  editId,
  setEditId,
  setForm,
  validated,
  submitLoading,
}) => {
  return (
    <form
      noValidate
      className={validated ? "was-validated" : ""}
      onSubmit={handleSubmit}
    >
      <div
        className="modal fade"
        id="leadModal"
        data-bs-backdrop="static"
        data-bs-keyboard="false"
        tabIndex="-1"
        aria-labelledby="modalUser"
        ref={modalRef}
      >
        <div className="modal-dialog modal-user">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="modalUser">
                {editId ? "Edit User" : "Tambah User"}
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>

            <div className="modal-body">
              {/* Input Nama */}
              <div className="mb-2">
                <input
                  type="text"
                  className="form-control"
                  name="name"
                  placeholder="Nama"
                  value={form.name || ""}
                  onChange={handleChange}
                  required
                />
                <div className="invalid-feedback">Nama wajib diisi.</div>
              </div>

              {/* Input Email */}
              <div className="mb-2">
                <input
                  type="email"
                  className="form-control"
                  name="email"
                  placeholder="Email"
                  value={form.email || ""}
                  onChange={handleChange}
                  required
                />
                <div className="invalid-feedback">
                  Masukkan email yang valid.
                </div>
              </div>

              {/* Input Password */}
              <div className="mb-2">
                <input
                  type="password"
                  className="form-control"
                  name="password"
                  placeholder={editId ? "Password (opsional)" : "Password"}
                  value={form.password || ""}
                  onChange={handleChange}
                  required={!editId}
                />
                <div className="invalid-feedback">Password wajib diisi.</div>
              </div>

              {/* Select Role */}
              <div className="mb-2">
                <select
                  className="form-select"
                  name="role"
                  value={form.role || ""}
                  onChange={handleChange}
                  required
                >
                  <option value="">-- Pilih Role --</option>
                  <option value="admin">Admin</option>
                  <option value="user">User</option>
                  <option value="operational">Operational</option>
                </select>
                <div className="invalid-feedback">Role wajib dipilih.</div>
              </div>
            </div>

            <div className="modal-footer">
              {editId && (
                <button
                  type="button"
                  className="btn btn-secondary me-auto"
                  onClick={() => {
                    setEditId(null);
                    setForm({ ...form, id: null });
                  }}
                >
                  Batal Edit
                </button>
              )}
              <button
                type="button"
                className="btn btn-secondary"
                data-bs-dismiss="modal"
              >
                Close
              </button>
              <button
                type="submit"
                className="btn btn-primary"
                disabled={submitLoading}
              >
                {submitLoading ? "Memproses..." : editId ? "Update" : "Tambah"}
              </button>
            </div>
          </div>
        </div>
      </div>
    </form>
  );
};

export default UserModal;
